var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "../../element-factory";
import { SurveyElementBase } from "../../reactquestion_element";
var SliderLabelItem = /** @class */ (function (_super) {
    __extends(SliderLabelItem, _super);
    function SliderLabelItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SliderLabelItem.prototype.getStateElement = function () {
        return this.item;
    };
    Object.defineProperty(SliderLabelItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SliderLabelItem.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    SliderLabelItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
    };
    SliderLabelItem.prototype.renderElement = function () {
        var _a = this.question, cssClasses = _a.cssClasses, handleLabelPointerUp = _a.handleLabelPointerUp, getLabelCss = _a.getLabelCss, getPercent = _a.getPercent;
        var _b = this.item, value = _b.value, locText = _b.locText;
        var labelText = null;
        var labelTextSecondary = null;
        if (this.item.showValue) {
            labelText = React.createElement("div", { className: cssClasses.labelText }, this.item.value);
            labelTextSecondary = React.createElement("div", { className: cssClasses.labelTextSecondaryMode }, this.renderLocString(locText));
        }
        else {
            labelText = React.createElement("div", { className: cssClasses.labelText }, this.renderLocString(locText));
        }
        return React.createElement("div", { key: this.item.uniqueId, className: getLabelCss(locText), style: { left: getPercent(value) + "%" }, onPointerUp: function (e) { handleLabelPointerUp(e.nativeEvent, value); } },
            React.createElement("div", { className: cssClasses.labelTick }),
            React.createElement("div", { className: cssClasses.labelTextContainer },
                labelText,
                labelTextSecondary));
    };
    return SliderLabelItem;
}(SurveyElementBase));
export { SliderLabelItem };
ReactElementFactory.Instance.registerElement("sv-slider-label-item", function (props) {
    return React.createElement(SliderLabelItem, props);
});
